import React, { useState } from "react";
import { reportFeedItem } from "../../api";

const REASONS = [
  ["dialect", "ليست فصحى / عامّيّة"],
  ["spam", "إزعاج متكرّر"],
  ["abuse", "إساءة أو تنمّر"],
  ["inappropriate", "محتوى غير لائق"],
  ["off_topic", "خارج الموضوع"],
  ["other", "سبب آخر"],
];

/**
 * FeedReportModal — majlis-styled, Arabic, RTL. Reports go to the admin
 * queue; enough unique reports auto-hide the post pending review.
 *
 * Props: postId | commentId (one), onClose.
 */
export default function FeedReportModal({ postId = null, commentId = null, onClose }) {
  const [reason, setReason] = useState("dialect");
  const [detail, setDetail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      await reportFeedItem({ postId, commentId, reason, detail });
      setDone(true);
      setTimeout(onClose, 1400);
    } catch (e) {
      setError(e.status === 409 ? "سبق أن بلّغتَ عن هذا." : "تعذّر إرسال البلاغ.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      dir="rtl"
      lang="ar"
      className="majlis-scope fixed inset-0 z-[60] flex items-center justify-center p-4 font-plex"
      style={{ background: "rgba(0, 0, 0, 0.45)" }}
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm rounded-[14px] px-5 py-4"
        style={{
          background: "var(--mj-surface)",
          border: "1px solid var(--mj-gold-line)",
          boxShadow: "0 12px 30px rgba(0, 0, 0, 0.45)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-[15px] font-bold mb-2.5" style={{ color: "var(--mj-cream)" }}>
          الإبلاغ عن {commentId ? "التعليق" : "المنشور"}
        </h3>
        {done ? (
          <p className="text-sm py-4" style={{ color: "var(--mj-gold)" }} role="status">
            تمّ استلامُ البلاغ — جزاكم الله خيرًا.
          </p>
        ) : (
          <>
            <div className="flex flex-col gap-1.5">
              {REASONS.map(([value, label]) => (
                <label
                  key={value}
                  className="flex items-center gap-2.5 text-[13.5px] cursor-pointer rounded-lg px-2 py-1"
                  style={{
                    color: reason === value ? "var(--mj-cream)" : "var(--mj-muted)",
                    background: reason === value ? "var(--mj-raised)" : "transparent",
                  }}
                >
                  <input
                    type="radio"
                    name="feed-report-reason"
                    checked={reason === value}
                    onChange={() => setReason(value)}
                  />
                  {label}
                </label>
              ))}
            </div>
            <textarea
              dir="rtl"
              className="w-full rounded-xl px-3 py-2 text-[13px] mt-3 outline-none"
              style={{
                background: "var(--mj-raised)",
                border: "1px solid var(--mj-line)",
                color: "var(--mj-cream)",
              }}
              rows={2}
              placeholder="تفاصيل تُعينُ المراجعين (اختياري)"
              value={detail}
              onChange={(e) => setDetail(e.target.value)}
            />
            {error && (
              <p className="text-[12px] mt-2 px-1" style={{ color: "var(--mj-flag)" }}>{error}</p>
            )}
            <div className="flex gap-2 mt-3.5">
              <button
                onClick={onClose}
                className="flex-1 rounded-full px-3 py-2 text-[13px] font-semibold"
                style={{ color: "var(--mj-muted)", border: "1px solid var(--mj-line)" }}
              >
                إلغاء
              </button>
              <button
                onClick={submit}
                disabled={busy}
                className="flex-1 rounded-full px-3 py-2 text-[13px] font-bold disabled:opacity-50"
                style={{ background: "var(--mj-flag)", color: "var(--mj-bg)" }}
              >
                {busy ? "جارٍ الإرسال…" : "بلّغ"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
